/**
 * Distributes items across columns using round-robin (modulo) distribution.
 * This ensures items are distributed evenly across columns while maintaining
 * the original order within each column.
 * 
 * @param {Array} data - Array of items to distribute
 * @param {number} columns - Number of columns to distribute across
 * @returns {Array<Array<{item: any, originalIndex: number}>>} Array of column arrays
 * 
 * @example
 * distributeItems(['a', 'b', 'c', 'd', 'e'], 3)
 * // Returns:
 * // [
 * //   [{ item: 'a', originalIndex: 0 }, { item: 'd', originalIndex: 3 }],
 * //   [{ item: 'b', originalIndex: 1 }, { item: 'e', originalIndex: 4 }],
 * //   [{ item: 'c', originalIndex: 2 }]
 * // ]
 */
export const distributeItems = (data, columns) => {
  if (!data || data.length === 0 || columns < 1) {
    return Array.from({ length: columns }, () => []);
  }

  const columnArrays = Array.from({ length: columns }, () => []);

  data.forEach((item, index) => {
    const columnIndex = index % columns;
    columnArrays[columnIndex].push({ item, originalIndex: index });
  });

  return columnArrays;
};
